import Core from '../core';
import { AxiosError, AxiosResponse } from 'axios';

async function getannouncementList(company_id: number, employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpAnnoucements?companyId=${company_id}&empId=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
export const announcementService = {
  getannouncementList,
};
